import { logger } from '@/lib/logger';

const STORAGE_KEY_PREFIX = 'ahoy-collapsed-nav-sections-';

function getStorageKey(orgId: string): string {
  return `${STORAGE_KEY_PREFIX}${orgId}`;
}

export function getCollapsedNavSections(
  orgId: string | undefined
): Set<string> {
  if (!orgId) {
    return new Set<string>();
  }

  try {
    const raw = localStorage.getItem(getStorageKey(orgId));
    if (!raw) {
      return new Set<string>();
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return new Set<string>();
    }
    return new Set(parsed.filter((x): x is string => typeof x === 'string'));
  } catch (err) {
    logger.warn('Failed to read collapsed nav sections from localStorage', {
      component: 'collapsed-nav-sections',
      error: String(err),
    });
    return new Set<string>();
  }
}

export function setCollapsedNavSections(
  orgId: string,
  sections: Set<string>
): void {
  try {
    localStorage.setItem(getStorageKey(orgId), JSON.stringify([...sections]));
  } catch (err) {
    logger.warn('Failed to persist collapsed nav sections to localStorage', {
      component: 'collapsed-nav-sections',
      error: String(err),
    });
  }
}

export function toggleCollapsedNavSection(
  orgId: string,
  sectionId: string
): Set<string> {
  const current = getCollapsedNavSections(orgId);
  if (current.has(sectionId)) {
    current.delete(sectionId);
  } else {
    current.add(sectionId);
  }
  setCollapsedNavSections(orgId, current);
  return current;
}
